document.addEventListener('readystatechange', () => {
    if (document.readyState === 'complete') {
        /* Collapsible blocks on measure page */
        let coll = document.getElementsByClassName("toggle-button");
        let i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;

                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }

        /* Show content on measure block mobile  */
        let toggleButton = document.getElementsByClassName("toggle-more-button");
        let j;

        for (j = 0; j < toggleButton.length; j++) {
            toggleButton[j].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.parentNode.previousElementSibling;

                if (content.classList.contains("mobile-readmore")) {
                    content.classList.remove("mobile-readmore");
                } else {
                    content.classList.add("mobile-readmore");
                }
            });
        }
    }
});
